/**
 *  预览弹出框
 * 
 */
"use strict";
angular.module("createCompanyManuModule", []).controller("createCompanyManuController", ["$scope","transParams", "$modalInstance", "trsHttpService", "$q", 'modalDialog', 'trsspliceString','$validation',
  function($scope, transParams, $modalInstance, trsHttpService, $q, modalDialog, trsspliceString,$validation) {
    initStatus();
    initData();
      /**
       * [initStatus description]
       * @return {[type]} [description]
       */
      function initStatus() {
          $scope.status={
              type:transParams.type,
              operation: transParams.type == 'create' ? '新建' : '编辑',
              item:transParams.item,
              departmentType:"单位",
          };
          /**
           * [saveDepartUnintParams description] 新建或编辑单位
           * @return {[type]} [description]
           */
          $scope.saveDepartUnintParams={
              serviceid: "mlf_departdoc",
              methodname: "saveDepartUnint",
              DepartmentaldocId: 0,
              DepartName:'',
              DepartDesc:'',
          };
      }

      /**
       * [initData description]
       * @return {[type]} [description]
       */
      function initData() {
          if($scope.status.type=='edit'){
               $scope.companyName=$scope.status.item.DEPARTNAME;
               $scope.companyDesc=$scope.status.item.DEPARTDESC;
          }
      }
    /**
     * [confirm description] 提交
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        $scope.createCompanyManu.$pending = {};
        $validation.validate($scope.createCompanyManu).success(function(){
            if($scope.status.type=='edit'){
                $scope.saveDepartUnintParams.DepartmentaldocId=$scope.status.item.DEPARTMENTALDOCID;
            };
            $scope.saveDepartUnintParams.DepartName=$scope.companyName;
            $scope.saveDepartUnintParams.DepartDesc=$scope.companyDesc;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.saveDepartUnintParams, "get").then(function(data) {
                if(data.ISSUCCESS=='true'){
                    modalDialog.alertType($scope.status.operation+'成功', '', 'success', false, function() {
                        $modalInstance.close('success');
                    });
                }
            });
        }).error(function(){
            return;
        });
    };
      /**
       * [cancel description] 取消
       * @return {[type]} [description]
       */
      $scope.cancel = function() {
          $modalInstance.close('cancel');
      };
  }
]);
